import { get } from 'axios'

const getLabelByScore = score => {
  if (score === null) return undefined
  const scoreLabel = score.toString()
  return scoreLabel >= 10 ? score : Number(score.toFixed(2))
}

const getState = score => {
  if (score === undefined) return 'light'
  if (score < 6) return 'secondary'
  if (score < 8) return 'orange'
  return 'lima'
}

export const getReportsHistoryByGroup = groupId =>
  get(`reports/${groupId || 'company'}/history`)

export const getReportsByGroup = groupId => {
  return get(`reports/${groupId || 'company'}`).then(res => {
    if (res.status === 204) {
      const indexes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      const fakeMetrics = indexes.map(id => ({
        id,
        state: 'light',
        score: undefined,
      }))
      const fakeSmartMetrics = [1, 2, 3].map(id => ({
        id,
        state: 'light',
        score: undefined,
      }))
      return {
        metrics: fakeMetrics,
        smart_metrics: fakeSmartMetrics,
        score: undefined,
        message: true,
        isEmptyState: true,
      }
    }

    if (!res.data.report) return {}

    res.data.report.metrics = res.data.report.metrics.map(metric => {
      // eslint-disable-next-line camelcase
      const getLink = ({ metric_id }) => {
        return { name: 'company.metric', params: { metricId: metric_id } }
      }

      const state = getState(metric.score)
      const scoreLabel = getLabelByScore(metric.score)
      const link = getLink(metric)

      return Object.assign({}, metricConfig[metric.metric_id], metric, {
        id: metric.metric_id,
        state,
        scoreLabel,
        link,
      })
    })

    res.data.report.smart_metrics = res.data.report.smart_metrics.map(sm => {
      const state = getState(sm.score)
      const scoreLabel = getLabelByScore(sm.score)

      const metricId = sm.metric_id
      return Object.assign({}, { icon: `/metrics/${metricId}.svg` }, sm, {
        id: metricId,
        state,
        scoreLabel,
      })
    })

    return res.data.report
  })
}

export const getMetricById = (metricId, groupId = 'company') => {
  return get(`reports/${groupId}/metrics/${metricId}`).then(response => {
    const metric = response.data.metric || { submetrics: [] }
    metric.submetrics = metric.submetrics.map(submetric => {
      const state = getState(submetric.score)
      const scoreLabel = getLabelByScore(submetric.score)

      return Object.assign({}, submetric, {
        id: submetric.submetric_id,
        state,
        scoreLabel,
      })
    })

    return Object.assign({}, metric, metricConfig[metricId])
  })
}

export const getEnps = groupId => {
  return get(`enpscores/${groupId || 'company'}`).then(res => {
    if (res.status === 204) {
      return null
    }
    return res.data.enpscore
  })
}

export const getLnps = groupId => {
  return get(`lnpscores/${groupId || 'company'}`).then(res => {
    if (res.status === 204) {
      return null
    }
    return res.data.lnpscore
  })
}

export default {
  getReportsByGroup,
  getMetricById,
  getEnps,
  getLnps,
  getReportsHistoryByGroup,
}

const metricConfig = {
  peersRelationship: { icon: '/metrics/relacao_equipe.svg' },
  ambassadorship: { icon: '/metrics/enps.svg' },
  happiness: { icon: '/metrics/felicidade.svg' },
  personalGrowth: { icon: '/metrics/crescimento_pessoal.svg' },
  wellness: { icon: '/metrics/bemestar.svg' },
  feedback: { icon: '/metrics/feedback.svg' },
  managerRelationship: { icon: '/metrics/relacao_gestor.svg' },
  recognition: { icon: '/metrics/reconhecimento.svg' },
  satisfaction: { icon: '/metrics/satisfacao.svg' },
  alignment: { icon: '/metrics/alinhamento.svg' },
}
